import { render, staticRenderFns } from "./BranchSelectorZasilkovna.vue?vue&type=template&id=67077bfe&"
import script from "./BranchSelectorZasilkovna.js?vue&type=script&lang=js&"
export * from "./BranchSelectorZasilkovna.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports